<script lang="ts">
  import cssVars, { cssVarsAsStyles } from "../../utils/cssVars";

  /**
   * Number of vertical columns in a small/mobile device
   *
   * @defaultValue `4`
   */
  export let smCols: number = 4;
  /**
   * Number of vertical columns in a medium/tablet device
   *
   * @defaultValue `8`
   */
  export let mdCols: number = 8;
  /**
   * Number of vertical columns in a large/desktop device
   *
   * @defaultValue `12`
   */
  export let lgCols: number = 12;
  /**
   * Number of vertical columns in a xl/desktop device
   *
   * @defaultValue `12`
   */
  export let xlCols: number = 12;
  /**
   * Number of vertical columns in a xxl/desktop device
   *
   * @defaultValue `12`
   */
  export let xxlCols: number = 12;
  /**
   * Grid gap on a small/mobile device
   *
   * @defaultValue `"40px"`
   */
  export let smGap: string = "40px";
  /**
   * Grid gap on a medium/tablet device
   *
   * @defaultValue `"40px"`
   */
  export let mdGap: string = "40px";
  /**
   * Grid gap on a large/desktop device
   *
   * @defaultValue `"48px"`
   */
  export let lgGap: string = "48px";
  /**
   * Grid gap on a xl/desktop device
   *
   * @defaultValue `"64px"`
   */
  export let xlGap: string = "64px";
  /**
   * Grid gap on a xxl/desktop device
   *
   * @defaultValue `"72px"`
   */
  export let xxlGap: string = "72px";

  $: styleVars = {
    smCols,
    mdCols,
    lgCols,
    xlCols,
    xxlCols,
    smGap,
    mdGap,
    lgGap,
    xlGap,
    xxlGap,
  };
</script>

<style lang="scss">
  div {
    display: grid;
    column-gap: var(--smGap, 32px);
    row-gap: var(--smGap, 32px);
    grid-template-columns: repeat(var(--smCols, 4), 1fr);
  }

  @media (min-width: $md) {
    div {
      column-gap: var(--mdGap, 40px);
      row-gap: var(--mdGap, 40px);
      grid-template-columns: repeat(var(--mdCols, 8), 1fr);
    }
  }

  @media (min-width: $lg) {
    div {
      column-gap: var(--lgGap, 48px);
      row-gap: var(--lgGap, 48px);
      grid-template-columns: repeat(var(--lgCols, 12), 1fr);
    }
  }

  @media (min-width: $xl) {
    div {
      column-gap: var(--xlGap, 64px);
      row-gap: var(--xlGap, 64px);
      grid-template-columns: repeat(var(--xlCols, 12), 1fr);
    }
  }

  @media (min-width: $xxl) {
    div {
      column-gap: var(--xxlGap, 72px);
      row-gap: var(--xxlGap, 72px);
      grid-template-columns: repeat(var(--xxlCols, 12), 1fr);
    }
  }
</style>

<div use:cssVars={styleVars} style={cssVarsAsStyles(styleVars)} {...$$props}>
  <slot />
</div>
